import { ChatHistoryItem } from '@/pages/ISWAN_CHAT/interface';
import {
  conversationsForDelete,
  conversationsRename,
  findConversations,
} from '@/services/AiService';
import { useModel } from '@umijs/max';
import { message } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import {onCommonH5Callback} from "@/services/h5Service";
import {aiSelectData} from "@/pages/ISWAN_CHAT/components/AISelectMenu/index.data";

export const useChatHistory = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [aiType, _, aiTypeRef] = useModel('ISWAN_CHAT.aiType');
  const [chatHistory, setChatHistory] = useState<ChatHistoryItem[]>([]);

  async function loadFromRemote() {
    if (aiType === null) {
      return;
    }

    const hs = await findConversations({ limit: 100, $ai_type: aiTypeRef.current });
    setChatHistory(
      hs.data.map((item: { id: any; name: any; created_at: any }) => {
        return {
          conversationId: item.id,
          key: item.id,
          label: item.name,
          timestamp: dayjs.unix(item.created_at).valueOf(),
        };
      }),
    );
  }

  useEffect(() => {
    loadFromRemote();
    const name = (() => {
      const item = aiSelectData.find((e) => e.value === aiType);
      if (item === undefined) return '';
      return item.label;
    })();
    const params = {
      'actionKey':'aiTypeAfterChange',
      'routeName': name,
      'pathName' : location.pathname,
    }
    onCommonH5Callback(params);
  }, [aiType]);

  async function deleteById(conversationId: string) {
    if (aiType === null) {
      return;
    }
    const res = await conversationsForDelete({
      conversationId,
      $ai_type: aiTypeRef.current,
    });
    console.log(res, 'res');
    if (res?.result === 'success') {
      loadFromRemote();
      message.success('删除成功');
    }
  }

  async function renameById(conversationId: string, newName: string) {
    if (!newName.trim()) {
      message.error('请输入内容');
      return;
    }
    if (aiType === null) {
      return;
    }
    const res = await conversationsRename({
      conversationId,
      name: newName,
      $ai_type: aiType,
    });
    console.log(res, 'res');
    if (res?.id === conversationId) {
      loadFromRemote();
      message.success('操作成功');
    }
  }

  useEffect(() => {
    loadFromRemote();
  }, []);

  // function getLabelFromMessages(messages: MessageItem[]) {
  //   const firstUserMsg = messages.find((item) => item.role === 'user');
  //   if (firstUserMsg === undefined) {
  //     return '新对话';
  //   }
  //   return firstUserMsg.content.slice(0, 25);
  // }

  // function create(conversationId: string, messages: MessageItem[], label?: string) {
  //   console.log(conversationId, 'conversationId');
  //   const item: ChatHistoryItem = {
  //     key: randomStr(),
  //     label: label ? label : getLabelFromMessages(messages),
  //     timestamp: dayjs().valueOf(),
  //     conversationId,
  //     messages,
  //   };
  //
  //   setChatHistory((prev) => {
  //     return [item, ...prev];
  //   });
  //   console.log(item, 'item');
  //   return item;
  // }
  //
  // function update(key: string, messages: MessageItem[], label?: string) {
  //   setChatHistory((prev) => {
  //     const copyPrev = [...prev];
  //     const index = copyPrev.findIndex((e) => e.key === key);
  //     if (index === -1) {
  //       return prev;
  //     }
  //     copyPrev[index] = {
  //       ...copyPrev[index],
  //       messages,
  //       label: label ? label : getLabelFromMessages(messages),
  //     };
  //     saveToRemote(copyPrev);
  //     return copyPrev;
  //   });
  // }

  return {
    chatHistory,
    loadFromRemote,
    deleteById,
    renameById,
  };
};
